import * as React from "react";
import Svg, { Rect, G, Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={38}
      height={38}
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Rect width={38} height={38} rx={8} fill="#F9F9F9" />
      <G fill="#333">
        <Path d="M23.974 8.89a.3.3 0 00-.512.212v2.895a.3.3 0 00.3.3h2.895a.3.3 0 00.212-.512L23.974 8.89zM18.521 17.79h.518l-.257-.682-.26.683z" />
        <Path d="M22.816 13.586a.644.644 0 01-.644-.645V9a1 1 0 00-1-1h-9.527a.645.645 0 00-.645.645v20.71c0 .356.289.645.645.645h15.468a.645.645 0 00.645-.645v-14.77a1 1 0 00-1-1h-3.942zm-1.312 5.277l.674-.957a1 1 0 000-1.15l-.5-.713a.537.537 0 01.878-.618.838.838 0 001.37 0 .537.537 0 11.878.619l-.502.712a1 1 0 000 1.151l.672.956a.537.537 0 11-.878.618l-.039-.055a1 1 0 00-1.635 0l-.04.055a.537.537 0 11-.878-.619zm-2.152-3.285l.006.015 1.279 3.39a.537.537 0 01-1.005.378.768.768 0 00-.718-.496h-.269a.773.773 0 00-.723.498.537.537 0 11-1.004-.382l1.291-3.39.005-.011a.613.613 0 011.138-.001zm-5.13.694a.537.537 0 110-1.075h1.9a.537.537 0 110 1.075.416.416 0 00-.417.415v2.485a.537.537 0 01-1.074 0V16.68a.408.408 0 00-.408-.409z" />
      </G>
    </Svg>
  );
}

export default SvgComponent;
